import { render } from "./ProductBoxWideSegmentImage.vue?vue&type=template&id=709fc17e&ts=true"
import script from "./ProductBoxWideSegmentImage.vue?vue&type=script&lang=ts"
export * from "./ProductBoxWideSegmentImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__